import React from 'react';
import {
    Col, Row, Container,
} from "react-bootstrap";
import { isMobile } from 'react-device-detect';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { useSelector } from 'react-redux';
import getBrandName from "app/shared/utils/BrandHelper";
import { getFeatureFlagValueByBrand } from 'app/shared/utils/utilityFunctions';
import { RootState } from '../../store';

const SignupHeader: React.FC = () => {
    const {
        rewardsLogoPath, signUpHeaderText,
    } = getBrandName();
    const features = useSelector((state: RootState) => state.auth.configs.env);
    const signUpHeaderSubText = getFeatureFlagValueByBrand(features.SIGNUP_HEADER_SUBTEXT);

    const appInsights = useAppInsightsContext();
    if (appInsights) {
        appInsights.trackPageView({
            name: "SignupHeader",
        });
        const metricData = {
            average: 5,
            name: "React Component Engaged Time (seconds)",
            sampleCount: 1,
        };
        const additionalProperties = { "Component Name": 'SignupHeader' };
        appInsights.trackMetric(metricData, additionalProperties);
    }

    return (
        <Container className="d-flex align-items-center flex-column my-account">
            <img
                className={`sign-up-logo ${isMobile ? "headerLogoImageMobile" : "headerLogoImage"}`}
                src={rewardsLogoPath}
                alt="Sign up"
            />
            <Row>
                <Col className="text-center" md={{ span: 8, offset: 2 }}>
                    <h3 className="join-now-title mt-4">{signUpHeaderText}</h3>
                    <p className="signOn-subText-Light">{signUpHeaderSubText}</p>
                </Col>
            </Row>
        </Container>
    );
};

export default SignupHeader;
